import { useState } from 'react';

//@ts-ignore
import { Loading, EmptyPage, Avatar, LoadingIcon } from '@microui/react-ui';
//@ts-ignore
import { MicroIcon } from '@microui/react-icons';
import { redirectTo } from 'libs/utils';

const TenantClientList = ({ loading = true, data = [], info }) => {
  const [requesting, setRequesting] = useState(false);
  const [selectClient, setSelectClient] = useState(null);

  const handleRequest = (item) => {
    if (requesting || !item?.clientUri) return;

    setRequesting(true);
    setSelectClient(item);
    redirectTo(`${item?.clientUri}/${info?.id}`);
  }

  if (loading)
      return <Loading size="large" loadingText="Đang tải thông tin kênh" />;

  if (!data || data.length == 0)
    return <EmptyPage />;

  return (
    <div className="p-6 h-[calc(100vh-310px)] overflow-y-auto">
      <div className="grid grid-cols-2 lg:grid-cols-3 3xl:grid-cols-4 gap-5 w-full">
        {
          data.map((e) => {
            return (
              <div key={e.id} className="h-[200px] w-auto shadow-sm-custom bg-white rounded-8 p-[18px] flex flex-col justify-between">
                <div className="flex gap-[10px]">
                  <Avatar
                    size='large'
                    type={'square'}
                    value={e?.avatar || e?.clientName}
                    data={{
                      name: e?.clientName,
                      email: e?.description
                    }}
                    avatarStyle={{
                      backgroundColor: 'var(--microui-color-primary)',
                      color: 'white',
                      fontSize: 25,
                    }}
                  />
                </div>
                
                <div className="flex self-end">
                  <div className={`text-buttom-2 font-medium cursor-pointer flex gap-2`}>
                    <button
                        className="flex items-center cursor-pointer"
                        onClick={() => handleRequest(e)}
                    >
                        {selectClient?.id == e.id ? (
                            <>
                              <LoadingIcon size="small" type="ball" className="mb-[1px]" />
                            </>
                        ) : (
                            <>
                              <span className="mr-1 text-primary">Truy cập</span>
                              <MicroIcon icon="arrow-right-alt" theme="filled" color="#1672EC" className="mb-[1px]" />
                            </>
                        )}
                    </button>
                  </div>
                </div>
              </div>
            )
          })
        }
      </div>
    </div>
  );
}

export default TenantClientList;